import { ChangeDetectorRef, Directive, OnInit } from '@angular/core';
import { ISummaryReport, ResponsibleType } from '@shared/interfaces';
import { ActivatedRoute, Router } from '@angular/router';
import { GuardService } from '@shared/services/guard.service';
import { MainViewDirective } from '@shared/directives';
import { CacheService, NavigationService, SummaryReportService } from '@shared/services';
import { Location } from '@angular/common';
import { SortByOption, SummaryReportGroupByOption } from '@shared/enums';
import { SummaryReportQuery } from '@monorepo/interfaces';

@Directive()
export class SummaryReportDirective extends MainViewDirective<ISummaryReport> implements OnInit {
    constructor(
        protected guardService: GuardService,
        protected changeDetection: ChangeDetectorRef,
        protected cacheService: CacheService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected location: Location,
        protected navigationService: NavigationService,
        protected summaryReportService: SummaryReportService
    ) {
        super(guardService, changeDetection, cacheService, router, route, location, navigationService);
        this.type = 'summary-reports';
        this.selectedGroupByOption = SummaryReportGroupByOption.none;
    }

    public async ngOnInit(): Promise<void> {
        this.reportingPeriod = '';
        await super.ngOnInit();
    }

    protected async loadData(): Promise<void> {
        let result: ISummaryReport[];
        if (!this.reportingPeriod) {
            result = await this.summaryReportService.getAll();
        } else {
            const query: SummaryReportQuery = {
                reportingYear: this.reportingPeriod
            };
            result = await this.summaryReportService.filter(query);
        }
        this.data = this.items = result;
    }

    protected get groupByOption(): typeof SummaryReportGroupByOption {
        return SummaryReportGroupByOption;
    }

    protected group(groupBy: SummaryReportGroupByOption): void {
        this.groupedItems = {};
        switch (groupBy) {
            case SummaryReportGroupByOption.responsibility: {
                for (const responsibleType of [ResponsibleType.sag, ResponsibleType.rc]) {
                    const reports = this.items.filter(
                        summaryReport => summaryReport.responsibleType === responsibleType
                    );
                    if (reports.length > 0) {
                        this.groupedItems[responsibleType] = reports;
                    }
                }
                break;
            }
            case SummaryReportGroupByOption.year:
                this.groupedItems = this.items.reduce((acc, summaryReport) => {
                    const reportingYear = summaryReport.reportingYear;
                    if (!acc[reportingYear]) {
                        acc[reportingYear] = [];
                    }
                    acc[reportingYear].push(summaryReport);
                    return acc;
                }, {});
                break;
            case SummaryReportGroupByOption.none:
                this.groupedItems = {
                    all: this.items
                };
                break;
            default:
                console.error('Unknown groupBy option:', groupBy);
        }
        this.selectedGroupByOption = groupBy;
        this.changeDetection.detectChanges();
    }

    get pageSize(): number {
        return window.innerWidth >= 900 && window.innerWidth < 1248 ? 9 : 12;
    }

    get pageSizes(): number[] {
        return window.innerWidth >= 900 && window.innerWidth < 1248
            ? [3, 6, 9, 12, 15, 18, 21, 24, 27, 30]
            : [4, 8, 12, 16, 20, 24, 28, 32, 36, 40];
    }

    protected get sortByOptions(): { value: SortByOption; direction: 'asc' | 'desc' }[] {
        return [SortByOption.modifiedDate].flatMap(option => [
            { value: option, direction: 'asc' },
            { value: option, direction: 'desc' }
        ]);
    }
}
